export const CUSTOMER_UNIT_NOT_ASSOCIATED_WITH_CONTRACT_UNIT = 866;
export const APPOINTMENT_ALREADY_IN_QUEUE = 889;
export const SERVICE_AT_FULL_CAPACITY = 890;
export const PAST_SCHEDULE_START_TIME = 872;
export const CANNOT_EDIT_ONGOING_APPOINTMENT = 877;
export const NO_CONVERSATION_EXISTS = 878;
export const NO_SUMMARY = 856;
export const INVALID_PRESCRIPTIONS = 876;
export const IN_PROGRESS = 857;
export const CANCEL_IN_PROGRESS = 857;
export const FETCHED_BY_ANOTHER_PROVIDER = 887;
export const TIME_SLOT_IS_TAKEN = 911;
export const FLEXIBLE_SLOT_IS_TAKEN = 920;
export const PROVIDER_SELECTION_REQUIRED = 869;
export const PROVIDER_HAS_BEEN_UNASSIGNED = 871;
export const CONVERSATION_CONNECTING_OR_IN_PROGRESS = 923;

export const CANNOT_CREATE_GENERAL_ERROR = 999;

export const apiErrorMessagesMap = {
  [CUSTOMER_UNIT_NOT_ASSOCIATED_WITH_CONTRACT_UNIT]: {
    id: 'AdminConsole.Appointments.Create.CustomerNotRelatedToUnit',
    defaultMessage: '** Customer is not related to the unit',
    field: 'externalId',
  },
  [APPOINTMENT_ALREADY_IN_QUEUE]: {
    id: 'Patient.Appointment.Create.MoreThan1Appt.Body',
    defaultMessage: '** User can not create more than 1 appointment per service',
    title: {
      id: 'Patient.Appointment.Create.MoreThan1Appt.Title',
      defaultMessage: '** Could not create appointment',
    },
  },
  [PAST_SCHEDULE_START_TIME]: {
    id: 'Patient.Appointment.Create.TakenTimeSlot',
    defaultMessage: '** Time slot is overdue or taken by another customer',
    field: 'timeSlot',
    step: 1,
  },
  [NO_CONVERSATION_EXISTS]: {
    id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.NoConversation',
    defaultMessage: '** The appointment can not be closed as completed since no conversation was done',
    title: {
      id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.Title',
      defaultMessage: '** Appointment can not be closed',
    },
  },
  [NO_SUMMARY]: {
    id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.SummaryRequired',
    defaultMessage: '** The appointment can not be closed as completed, since Summary is required',
    title: {
      id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.Title',
      defaultMessage: '** Appointment can not be closed',
    },
  },
  [INVALID_PRESCRIPTIONS]: {
    id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.PrescriptionNotValid',
    defaultMessage: '** The appointment can not be closed as completed, since the prescription is not valid',
    title: {
      id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.Title',
      defaultMessage: '** Appointment can not be closed',
    },
  },
  [IN_PROGRESS]: {
    id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.ConvInProgress',
    defaultMessage: '** The appointment can not be closed, since it has a conversation in progress',
    field: 'state',
  },
  [FETCHED_BY_ANOTHER_PROVIDER]: {
    id: 'AdminConsole.Appointments.DetailedView.EditAppt.CanNotCloseAsCompleted.ApptIsFetched',
    defaultMessage: '** The provider name cannot be changed, since it is already fetched/viewed by another provider',
    field: 'providerUserId',
  },
  [CONVERSATION_CONNECTING_OR_IN_PROGRESS]: {
    id: 'AdminConsole.Appointments.AppointmentDetails.EditDialog.ProviderName.AlertApptIsConnecting',
    defaultMessage: '** Provider name can’t be updated while conversation status is connecting or in progress',
    field: 'providerUserId',
  },
  [TIME_SLOT_IS_TAKEN]: {
    id: 'Patient.Appointment.Create.TakenTimeSlot',
    defaultMessage: '** Time slot is overdue or taken by another customer',
    field: 'timeSlot',
    step: 1,
  },
  [FLEXIBLE_SLOT_IS_TAKEN]: {
    id: 'Patient.Appointment.Create.TakenTimeSlot',
    defaultMessage: '** Time slot is overdue or taken by another customer',
    field: 'flexible.from',
    step: 1,
  },
  [SERVICE_AT_FULL_CAPACITY]: {
    id: 'Patient.Appointment.Create.FullQueue.Dialog.Body',
    defaultMessage: '** Service queue is full and appointment can not be created. Please try again later',
    title: {
      id: 'Patient.Appointment.Create.FullQueue.Dialog.Title',
      defaultMessage: '** Queue is full',
    },
  },
  [CANNOT_EDIT_ONGOING_APPOINTMENT]: {
    id: 'AdminConsole.Appointments.DetailedView.AppointmentDetails.OngoingApptError.Body',
    defaultMessage: '** Appointment is ongoing, therefore it can not be canceled',
    title: {
      id: 'AdminConsole.Appointments.DetailedView.AppointmentDetails.OngoingApptError.Title',
      defaultMessage: '** Can not edit appointment',
    },
  },
  [PROVIDER_SELECTION_REQUIRED]: {
    id: 'AdminConsole.Appointments.CreateForm.MissingMandatoryFieldError.ProviderName',
    defaultMessage: '** Provider name selection is required',
    field: 'providerUserId',
    step: 0,
  },
  [PROVIDER_HAS_BEEN_UNASSIGNED]: {
    id: 'AdminConsole.Appointments.CreateForm.Provider.ProviderIsNotRelatedToService',
    defaultMessage: '** Selected provider is not related to the selected service',
    field: 'providerUserId',
    step: 0,
  },
  [CANNOT_CREATE_GENERAL_ERROR]: {
    id: 'NewConsultationWizard.MessagingConsultation.ConsultationCannotBeCreatedDialog.Body',
    defaultMessage: '** The consultation cannot be created due to a problem, please try again later',
    title: {
      id: 'NewConsultationWizard.MessagingConsultation.ConsultationCannotBeCreatedDialog.Title',
      defaultMessage: '** Consultation cannot be created',
    },
  },
};

export const cancelInProgress = {
  id: 'Appointments.CancelAppointment.UnableToCancel.Dialog.Body',
  defaultMessage: '** An ongoing appointment can not be canceled',
  title: {
    id: 'Appointments.CancelAppointment.UnableToCancel.Dialog.Title',
    defaultMessage: '** Appointment can not be cancelled',
  },
};

export const modalErrors = [
  NO_CONVERSATION_EXISTS,
  NO_SUMMARY,
  INVALID_PRESCRIPTIONS,
  SERVICE_AT_FULL_CAPACITY,
  CANNOT_EDIT_ONGOING_APPOINTMENT,
  APPOINTMENT_ALREADY_IN_QUEUE,
  CANCEL_IN_PROGRESS,
];

